import React, { useState, useContext, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'
import { CircleSpinner } from 'shared'
import { Heading } from '../../../../components/index'
import GeneratedLinkBox from './GeneratedLinkBox/GeneratedLinkBox'
import GenerateBtnBox from './GenerateBtnBox/GenerateBtnBox'
import SspContext from 'selfServicePortal/contexts/SspContext'
import createReferalLinkService from '../../../../services/ReferalLink/CreateReferalLinkService'
import getReferalLinkService from '../../../../services/ReferalLink/GetReferalLinkService'
import GetReferalLinkFriendsService from 'selfServicePortal/services/ReferalLink/GetReferalLinkFriendsService'
import { appRoutes } from 'selfServicePortal/constants/routes'
import './ReferFriends.scss'

interface ReferalLinkModel {
	partyId: string
	referralIdentifier: string
	referralLink: string
	validTo: string
	numberOfTimesUsed: number
	isActive: boolean
	status?: number
	details?: string
	validTimes: number
}

const ReferFriends = () => {
	const { t } = useTranslation()
	const { customerData } = useContext(SspContext)
	const [referalLink, setReferalLink] = useState<ReferalLinkModel>()
	const [referalLinkFriends, setReferalLinkFriends] = useState<any>()
	const [daysLeft, setDaysLeft] = useState(0)
	const [loading, setLoading] = useState<boolean>(true)
	const [loadingSmall, setLoadingSmall] = useState<boolean>(false)
	const location = useLocation()
	const navigate = useNavigate()

	const createReferalLink = async () => {
		setLoadingSmall(true)
		await createReferalLinkService(
			customerData?.customerId.toString() || '',
		)
			.then((dataLink: ReferalLinkModel) => {
				setReferalLink(dataLink)
			})
			.catch((err) => {
				console.log(err)
			})
			.finally(() => setLoadingSmall(false))
	}

	const getReferalLink = async () => {
		setLoading(true)
		await getReferalLinkService(customerData?.customerId.toString() || '')
			.then((dataLink: ReferalLinkModel) => {
				if (dataLink?.status !== 404) {
					setReferalLink(dataLink)
				} else {
					console.log(dataLink?.details)
				}
			})
			.catch((err) => {
				console.log(err)
			})
			.finally(() => setLoading(false))
	}

	const getReferalFriendsLink = async () => {
		// description text and terms and conditions
		setLoading(true)
		await GetReferalLinkFriendsService(
			customerData?.country.toString() || '',
		)
			.then((response) => {
				if (response?.status !== 404) {
					setReferalLinkFriends(response)
				}
			})
			.catch((err) => {
				console.log(err)
			})
			.finally(() => setLoading(false))
	}

	const calculateDays = useCallback(() => {
		if (referalLink) {
			const secDate = referalLink?.validTo
			const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
			const firstDate: any = new Date()
			const secondDate: any = new Date(secDate || '')
			const diffDays = Math.round(
				Math.abs((firstDate - secondDate) / oneDay),
			)
			setDaysLeft(diffDays)
		}
	}, [referalLink])

	useEffect(
		() => {
			if (customerData) {
				getReferalLink()
				getReferalFriendsLink()
				if (location.pathname === appRoutes.referfriends) {
					navigate('/')
				}
			}
		},
		[customerData], //eslint-disable-line
	)

	useEffect(() => {
		if (referalLink) {
			calculateDays()
		}
	}, [referalLink, calculateDays])

	return (
		<div className="fade-in faq container refer-friends">
			<div className="fixed-width my-5">
				<Heading title={t('ReferFriends')} />
				<div className="outer-container-box p-4 mb-4">
					{loading ? (
						<div className="outer-container-box-white">
							<CircleSpinner />
						</div>
					) : (
						<>
							<div className="outer-container-box-colored">
								<div
									className="refer-friend-inactive-description"
									dangerouslySetInnerHTML={{
										__html: referalLinkFriends?.instructions,
									}}></div>
							</div>
							<div className="outer-container-box-white">
								{referalLink?.isActive ? (
									<GeneratedLinkBox
										referalLink={referalLink}
										daysLeft={daysLeft}
									/>
								) : (
									<GenerateBtnBox
										createReferalLink={createReferalLink}
										loadingSmall={loadingSmall}
									/>
								)}
								<div className="btn-learn-more">
									<a
										href={referalLinkFriends?.moreInfoLink}
										target="_blank"
										rel="noopener noreferrer">
										{t('ReferFriendsLearnMore')}
									</a>
								</div>
							</div>
							<div className="outer-container-box-colored">
								<div className="refer-friend-inactive-description">
									<div
										className="refer-friend-inactive-description-columns"
										dangerouslySetInnerHTML={{
											__html: referalLinkFriends?.termsAndConditions,
										}}></div>
								</div>
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	)
}

export default ReferFriends
